/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Response containing security level hierarchy validation information
 * @export
 * @interface SecurityLevelHierarchyResponse
 */
export interface SecurityLevelHierarchyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SecurityLevelHierarchyResponse
     */
    valid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SecurityLevelHierarchyResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof SecurityLevelHierarchyResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof SecurityLevelHierarchyResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SecurityLevelHierarchyResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * Whether the security level hierarchy is valid
     * @type {boolean}
     * @memberof SecurityLevelHierarchyResponse
     */
    isValid?: boolean;
}

/**
 * Check if a given object implements the SecurityLevelHierarchyResponse interface.
 */
export function instanceOfSecurityLevelHierarchyResponse(value: object): value is SecurityLevelHierarchyResponse {
    return true;
}

export function SecurityLevelHierarchyResponseFromJSON(json: any): SecurityLevelHierarchyResponse {
    return SecurityLevelHierarchyResponseFromJSONTyped(json, false);
}

export function SecurityLevelHierarchyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityLevelHierarchyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'valid': json['valid'] == null ? undefined : json['valid'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'isValid': json['isValid'] == null ? undefined : json['isValid'],
    };
}

export function SecurityLevelHierarchyResponseToJSON(json: any): SecurityLevelHierarchyResponse {
    return SecurityLevelHierarchyResponseToJSONTyped(json, false);
}

export function SecurityLevelHierarchyResponseToJSONTyped(value?: SecurityLevelHierarchyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'valid': value['valid'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'isValid': value['isValid'],
    };
}

